"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPSLUtils = exports.TPSLErrorCode = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const TP_SL_FLAG_MAP = {
    [interface_1.FuturePositionSide.LONG]: { tp: 1, sl: -1 },
    [interface_1.FuturePositionSide.SHORT]: { tp: -1, sl: 1 },
};
const TP_SL_TYPE_MAP = {
    [interface_1.FuturePositionSide.LONG]: { tp: interface_1.TriggerType.GREATER_EQUAL, sl: interface_1.TriggerType.LESS_EQUAL },
    [interface_1.FuturePositionSide.SHORT]: { tp: interface_1.TriggerType.LESS_EQUAL, sl: interface_1.TriggerType.GREATER_EQUAL },
};
const ORDER_TP_SL_MODE_MAP = {
    [interface_1.FuturePositionSide.LONG]: { [interface_1.TriggerType.GREATER_EQUAL]: "tp", [interface_1.TriggerType.LESS_EQUAL]: "sl" },
    [interface_1.FuturePositionSide.SHORT]: { [interface_1.TriggerType.GREATER_EQUAL]: "sl", [interface_1.TriggerType.LESS_EQUAL]: "tp" },
};
var TPSLErrorCode;
(function (TPSLErrorCode) {
    /**做多止盈小于当前价格 */
    TPSLErrorCode["LONG_TP_LT_LATEST"] = "LONG_TP_LT_LATEST";
    /**做多止损大于当前价格 */
    TPSLErrorCode["LONG_SL_GT_LATEST"] = "LONG_SL_GT_LATEST";
    /**做多止损小于强平价 */
    TPSLErrorCode["LONG_SL_LT_LIQ_PRICE"] = "LONG_SL_LT_LIQ_PRICE";
    /**做空止盈大于当前价格 */
    TPSLErrorCode["SHORT_TP_GT_LATEST"] = "SHORT_TP_GT_LATEST";
    /**做空止损小于当前价格 */
    TPSLErrorCode["SHORT_SL_LT_LATEST"] = "SHORT_SL_LT_LATEST";
    /**做空止损大于强平价 */
    TPSLErrorCode["SHORT_SL_GT_LIQ_PRICE"] = "SHORT_SL_GT_LIQ_PRICE";
    /**设置价格非法 */
    TPSLErrorCode["INVALID_PRICE"] = "INVALID_PRICE";
})(TPSLErrorCode = exports.TPSLErrorCode || (exports.TPSLErrorCode = {}));
var TPSLUtils;
(function (TPSLUtils) {
    /**获取止盈止损的方向 */
    function getTPSLFlag(mode, side) {
        return TP_SL_FLAG_MAP[side][mode];
    }
    TPSLUtils.getTPSLFlag = getTPSLFlag;
    /**
     * 通过Percent计算价格
     * percent = 仓位方向 * 杠杆倍数 *（Price-持仓成本）/ 持仓成本
     * （Price-持仓成本） = (持仓成本 * percent)/(仓位方向 * 杠杆倍数)
     * Price = (持仓成本 * percent)/(仓位方向 * 杠杆倍数) + 持仓成本
     * @param params
     * @returns
     */
    function getTPSLPrice(params) {
        const { percent, side, leverage, avgPrice, mode } = params;
        const flag = getTPSLFlag(mode, side);
        return new trade_utils_lib_1.SafeDecimal(avgPrice).mul(percent).div(new trade_utils_lib_1.SafeDecimal(leverage).mul(flag)).add(avgPrice).toString();
    }
    TPSLUtils.getTPSLPrice = getTPSLPrice;
    /**
     * 通过价格获取Percent
     * 止盈 percent = 仓位方向 * 杠杆倍数 *（Price-持仓成本）/ 持仓成本
     * @param params
     */
    function getTPSLPercent(params) {
        const { price, side, leverage, avgPrice, mode } = params;
        const flag = getTPSLFlag(mode, side);
        const priceDecimal = new trade_utils_lib_1.SafeDecimal(price);
        if (priceDecimal.lte(0)) {
            return 0;
        }
        return new trade_utils_lib_1.SafeDecimal(price).sub(avgPrice).mul(flag).mul(leverage).div(avgPrice).toNumber();
    }
    TPSLUtils.getTPSLPercent = getTPSLPercent;
    /**
     * 获取止盈止损的盈亏
     */
    function getTPSLProfit(params) {
        const { price, avgPrice, positionQuantity } = params;
        return new trade_utils_lib_1.SafeDecimal(price).sub(avgPrice).mul(positionQuantity);
    }
    TPSLUtils.getTPSLProfit = getTPSLProfit;
    function checkTriggerPriceError(triggerPrice, latestPrice, side, mode, liqPrice, percent) {
        const price = new trade_utils_lib_1.SafeDecimal(triggerPrice);
        if (price.eq(0) || price.eq(latestPrice) || new trade_utils_lib_1.SafeDecimal(percent).eq(0)) {
            return {
                code: TPSLErrorCode.INVALID_PRICE,
            };
        }
        if (side === interface_1.FuturePositionSide.LONG) {
            // 做多 止盈 > 当前价格
            if (mode === "tp") {
                if (price.lte(latestPrice)) {
                    return {
                        code: TPSLErrorCode.LONG_TP_LT_LATEST,
                        data: { side, mode, condition: "LT", priceType: "latest", price: latestPrice },
                    };
                }
                return undefined;
            }
            // 做多止损
            if (price.gte(latestPrice)) {
                return {
                    code: TPSLErrorCode.LONG_SL_GT_LATEST,
                    data: { side, mode, condition: "GT", priceType: "latest", price: latestPrice },
                };
            }
            if (price.lte(liqPrice)) {
                return {
                    code: TPSLErrorCode.LONG_SL_LT_LIQ_PRICE,
                    data: { side, mode, condition: "LT", priceType: "estLiq", price: liqPrice },
                };
            }
            return undefined;
        }
        else {
            // 做空 止盈
            if (mode === "tp") {
                if (price.gte(latestPrice)) {
                    return {
                        code: TPSLErrorCode.SHORT_TP_GT_LATEST,
                        data: { side, mode, condition: "GT", priceType: "latest", price: latestPrice },
                    };
                }
                return undefined;
            }
            // 做空止损
            // 小于最新价格
            if (price.lte(latestPrice)) {
                return {
                    code: TPSLErrorCode.SHORT_SL_LT_LATEST,
                    data: { side, mode, condition: "LT", priceType: "latest", price: latestPrice },
                };
            }
            // 大于强平价格
            if (price.gte(liqPrice)) {
                return {
                    code: TPSLErrorCode.SHORT_SL_GT_LIQ_PRICE,
                    data: { side, mode, condition: "GT", priceType: "estLiq", price: liqPrice },
                };
            }
        }
        return undefined;
    }
    TPSLUtils.checkTriggerPriceError = checkTriggerPriceError;
    function getTriggerType(mode, side) {
        return TP_SL_TYPE_MAP[side][mode];
    }
    TPSLUtils.getTriggerType = getTriggerType;
    function getOrderTPSLMode(order) {
        const { position_side, trigger_type } = order;
        return ORDER_TP_SL_MODE_MAP[position_side][trigger_type];
    }
    TPSLUtils.getOrderTPSLMode = getOrderTPSLMode;
})(TPSLUtils = exports.TPSLUtils || (exports.TPSLUtils = {}));
